import React, { createContext, useState, useEffect } from 'react';


interface LockerManagementFileUploadProps {
    batchName: string
    selectedUsers: any []
    selectedGroups: any []
    files: File []
    isValid: boolean,
    setBatchName: (string) => void
    setSelectedUsers: (data: any[]) => void
    setSelectedGroups: (data: any[]) => void
    setFiles: (val: File[]) => void
    setFileErrors: (val: boolean) => void
    removeAll: (type: SearchType) => void
    clearAll: () => void
    uploadFiles: {fileName: string, file: File, errors: string[]}[]
    setUploadFiles: (files: {fileName: string, file: File, errors: string[]}[]) => void
}

export enum SearchType {
    USER = "user",
    GROUP = "group"
}

// Create context with placeholder functions - function definitions replaced in the provider
export const LockerManagementFileUploadContext = createContext<LockerManagementFileUploadProps>({
    batchName: '',
    selectedUsers: [],
    selectedGroups: [],
    files: [],
    isValid: false,
    setBatchName: (name: string) => {},
    setSelectedUsers: (data: any[]) => {},
    setSelectedGroups: (data: any[]) => {},
    setFiles: (val: File[]) => {},
    setFileErrors: (val: boolean) => {},
    removeAll: (type: SearchType) => {},
    clearAll:() => {},
    uploadFiles: [],
    setUploadFiles: (files: {fileName: string, file: File, errors: string[]}[]) => {}
});

export const LockerManagementFileUploadProvider = ({children}) => { 
    
    const [batchName, setBatchName] = useState<string>('');
    const [selectedUsers, setSelectedUsers ] = useState<any[]>([]);
    const [selectedGroups, setSelectedGroups ] = useState<any[]>([]);
    const [files, setFiles ] = useState<any[]>([]);
    const [uploadFiles, setUploadFiles] = useState<{fileName: string, file: File, errors: string[]}[]>([]);
    const [fileErrors, setFileErrors ] = useState<boolean>(false);
    const [isValid, setIsValid] = useState<boolean>(false);

    const hasSelectedUsers = !!selectedUsers.length
    const hasSelectedGroups = !!selectedGroups.length
    const hasFiles = !!files.length
    const totalFiles = files.length

    const getAndSetStateMap = {
        [SearchType.USER]: {state: selectedUsers, setState: setSelectedUsers},
        [SearchType.GROUP]: {state: selectedGroups, setState: setSelectedGroups}
    }
    
    useEffect(() => {
        if (hasFiles && (totalFiles <= 100) && (hasSelectedGroups || hasSelectedUsers) && !fileErrors){ 
            setIsValid(true);
        }
        else {
            setIsValid(false);
        } 
    },[hasSelectedUsers, hasSelectedGroups, hasFiles, fileErrors, totalFiles] )

    function removeAll(type) {
        const {setState} = getAndSetStateMap[type]
        setState([]);
    }

    function clearAll() {
        setBatchName('');
        setFiles([]);
        setFileErrors(false);
        setSelectedUsers([]);
        setSelectedGroups([]);
    }

    const lockerContextValues = { 
        selectedUsers,
        selectedGroups,
        files,
        isValid,
        batchName,
        setFiles,
        setFileErrors,
        setSelectedUsers,
        setSelectedGroups,
        removeAll,
        setBatchName,
        clearAll,
        uploadFiles,
        setUploadFiles
    }

    return (
        <LockerManagementFileUploadContext.Provider value={lockerContextValues}>
            {children}
        </LockerManagementFileUploadContext.Provider>
    )
}